import _ from "underscore";
import m from "mithril";
import {ImageItem} from "../../model/items/imageItem";
import {ScrollableDiv} from "../components/scrollableDiv";
import {ImagePreview} from "../components/imagePreview";
import ImageHighlighter from "../components/imageHighlighter";
import {Vnode} from "mithril";
import prop from "mithril/stream";

export class ImageView  {
	public static component = {
		view: (vnode: Vnode) => {
		    return m(ImageView, vnode.attrs);
        }
	};
	private showPreview: any;
    private cellItem: ImageItem;
    private imagePreview: null|ImagePreview = null;
    private imageUrl: string;

	constructor(vnode: Vnode|any) {
        this.showPreview = prop(false);
        this.cellItem = <ImageItem>vnode.attrs.cellItem;
        this.imageUrl = this.cellItem.questionary.getFileUrl(this.cellItem.file);
        if (this.cellItem.previewType === ImageItem.PreviewType.CLICK_TO_FULL_IMAGE) {
            this.imagePreview = new ImagePreview(this.imageUrl, () => {this.showPreview(false)})
        }
	}

	view() : any {
        if( this.cellItem.hasHighlighter()) {
            // @ts-ignore TODO
			return m(ImageHighlighter.component, {content: this.getContent(), highlighter: this.cellItem.highlighter});
		} else if (this.cellItem.hasViewport()) {
            // @ts-ignore TODO
			return m(ScrollableDiv.component, {content: this.getContent(), viewport: this.cellItem.viewport});
		} else {
			return this.getContent();
		}
	}

	private getContent() {

		var params: {[attr:string]:any} = {src: this.imageUrl};
		if (this.cellItem.hasScale()) {
			params['style'] = `width: ${this.cellItem.scale!.width}px; height: ${this.cellItem.scale!.height}px;`; // scale is checked before
		}

		if (this.cellItem.previewType === ImageItem.PreviewType.CLICK_TO_FULL_IMAGE) {
			params['style'] += 'cursor: pointer;';
			params['onclick'] = () => this.showPreview(true);
			return m('span.image', [
				this.getImage(params),
                // @ts-ignore
                this.showPreview() ? m(this.imagePreview) : null
            ]);
		} else {
			return this.getImage(params);
		}
	}

	private getImage(params: {[attr:string]:any}) {
		// Remove false values from imgParams
		return m('img.image', _.pick(params, _.identity));
	}
}
